module.exports = __webpack_public_path__ + "assets/e5dab62b8d9573cbfce003ef6c6b41bc.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/pick/FgSelect_Ver1.mp3
 ** module id = 493
 ** module chunks = 0
 **/